export const GOLDEN_NUMBER = 1.618;